import { AlertDefinition } from "../types";
import { WidgetKey } from "./widgets";
import { AlertDefinitionKey } from "./keys";

// Type-safe alert definition keys
// keys moved to ./keys

// Alert definitions - templates for creating alerts
export const alertDefinitions: Record<AlertDefinitionKey, AlertDefinition> = {
  // Main Hoist related
  MAIN_HOIST_1_SENSOR_ERROR: {
    id: "MAIN_HOIST_1_SENSOR_ERROR",
    type: "error",
    title: "Main Hoist 1 Sensor Error",
    message: "Sensor error detected on Main Hoist 1.",
    category: "mechanical",
    priority: 8,
  },

  MAIN_HOIST_2_SENSOR_ERROR: {
    id: "MAIN_HOIST_2_SENSOR_ERROR",
    type: "error",
    title: "Main Hoist 2 Sensor Error",
    message: "Sensor error detected on Main Hoist 2.",
    category: "mechanical",
    priority: 8,
  },

  MAIN_HOIST_DRIVE_ERROR: {
    id: "MAIN_HOIST_DRIVE_ERROR",
    type: "error",
    title: "Main Hoist Drive System Error",
    message:
      "Drive system error on Main Hoist. Check VFD status and motor connections.",
    category: "mechanical",
    priority: 9,
  },

  MAIN_HOIST_BRAKE_ERROR: {
    id: "MAIN_HOIST_BRAKE_ERROR",
    type: "error",
    title: "Main Hoist Brake System Error",
    message:
      "Brake system error on Main Hoist. Check HPU pressure and brake feedback.",
    category: "safety",
    priority: 10,
  },

  MAIN_HOIST_OVERLOAD: {
    id: "MAIN_HOIST_OVERLOAD",
    type: "error",
    title: "Main Hoist Overload Detected",
    message: "Overload detected on Main Hoist. Reduce load immediately.",
    category: "safety",
    priority: 10,
  },

  MAIN_HOIST_BLOCK_POSITION_PRE_HIGH: {
    id: "MAIN_HOIST_BLOCK_POSITION_PRE_HIGH",
    type: "warning",
    title: "Main hoist - block position pre-high",
    message: "Hook block approaching limit. Hoisting slowed for safety.",
    category: "safety",
    priority: 7,
  },

  MAIN_HOIST_BLOCK_POSITION_HIGH: {
    id: "MAIN_HOIST_BLOCK_POSITION_HIGH",
    type: "warning",
    title: "Main hoist - block position high",
    message: "Hook block at upper limit. Hoisting disabled, lowering only.",
    category: "safety",
    priority: 8,
  },

  // Boom Hoist related
  BOOM_HOIST_SENSOR_ERROR: {
    id: "BOOM_HOIST_SENSOR_ERROR",
    type: "error",
    title: "Boom Hoist Sensor Error",
    message: "Sensor error on Boom Hoist. Check connections and calibration.",
    category: "mechanical",
    priority: 8,
  },

  BOOM_HOIST_DRIVE_ERROR: {
    id: "BOOM_HOIST_DRIVE_ERROR",
    type: "error",
    title: "Boom Hoist Drive Error",
    message:
      "Drive error on Boom Hoist. Check VFD status and motor connections.",
    category: "mechanical",
    priority: 9,
  },

  BOOM_HOIST_BRAKE_ERROR: {
    id: "BOOM_HOIST_BRAKE_ERROR",
    type: "error",
    title: "Boom Hoist Brake Error",
    message:
      "Brake system error on Boom Hoist. Check HPU pressure and brake feedback.",
    category: "safety",
    priority: 10,
  },

  BOOM_HOIST_ANGLE_ERROR: {
    id: "BOOM_HOIST_ANGLE_ERROR",
    type: "error",
    title: "Boom Angle Sensor Error",
    message: "Boom angle sensor error. Check sensor calibration.",
    category: "mechanical",
    priority: 7,
  },

  // Slewing related
  SLEWING_DRIVE_ERROR: {
    id: "SLEWING_DRIVE_ERROR",
    type: "error",
    title: "Slewing Drive System Error",
    message: "Slewing drive error. Check VFD status and motor connections.",
    category: "mechanical",
    priority: 9,
  },

  SLEWING_BRAKE_ERROR: {
    id: "SLEWING_BRAKE_ERROR",
    type: "error",
    title: "Slewing Brake System Error",
    message:
      "Slewing brake system error. Check brake feedback and HPU pressure.",
    category: "safety",
    priority: 10,
  },

  SLEWING_ANGLE_ERROR: {
    id: "SLEWING_ANGLE_ERROR",
    type: "error",
    title: "Slewing Angle Sensor Error",
    message: "Slewing angle sensor error. Check encoder calibration.",
    category: "mechanical",
    priority: 7,
  },

  // Auxiliary Hoist related
  AUX_HOIST_SENSOR_ERROR: {
    id: "AUX_HOIST_SENSOR_ERROR",
    type: "error",
    title: "Auxiliary Hoist Sensor Error",
    message:
      "Sensor error on Auxiliary Hoist. Check connections and calibration.",
    category: "mechanical",
    priority: 8,
  },

  AUX_HOIST_DRIVE_ERROR: {
    id: "AUX_HOIST_DRIVE_ERROR",
    type: "error",
    title: "Auxiliary Hoist Drive Error",
    message:
      "Drive error on Auxiliary Hoist. Check VFD status and motor connections.",
    category: "mechanical",
    priority: 9,
  },

  AUX_HOIST_BRAKE_ERROR: {
    id: "AUX_HOIST_BRAKE_ERROR",
    type: "error",
    title: "Auxiliary Hoist Brake Error",
    message:
      "Brake system error on Auxiliary Hoist. Check HPU pressure and brake feedback.",
    category: "safety",
    priority: 10,
  },

  // Load Tugger related
  LOAD_TUGGER_11_ERROR: {
    id: "LOAD_TUGGER_11_ERROR",
    type: "error",
    title: "Load Tugger 11 Error",
    message: "Error on Load Tugger 11. Check system status and connections.",
    category: "mechanical",
    priority: 8,
  },

  LOAD_TUGGER_21_ERROR: {
    id: "LOAD_TUGGER_21_ERROR",
    type: "error",
    title: "Load Tugger 21 Error",
    message: "Error on Load Tugger 21. Check system status and connections.",
    category: "mechanical",
    priority: 8,
  },

  // Sling Hoist related
  SLING_HOIST_ERROR: {
    id: "SLING_HOIST_ERROR",
    type: "error",
    title: "Sling Hoist System Error",
    message: "Sling Hoist error. Check system status and connections.",
    category: "mechanical",
    priority: 8,
  },

  // EPU related
  EPU_POWER_ERROR: {
    id: "EPU_POWER_ERROR",
    type: "error",
    title: "EPU Power Supply Error",
    message:
      "EPU power supply error on circuit. Check circuit breakers and distribution.",
    category: "electrical",
    priority: 9,
  },

  EPU_VOLTAGE_ERROR: {
    id: "EPU_VOLTAGE_ERROR",
    type: "error",
    title: "EPU Voltage Monitor Error",
    message:
      "EPU voltage monitor error. Check voltage levels and monitoring equipment.",
    category: "electrical",
    priority: 8,
  },

  // Network related
  NETWORK_COMMUNICATION_ERROR: {
    id: "NETWORK_COMMUNICATION_ERROR",
    type: "error",
    title: "Network Communication Error",
    message:
      "Network communication error. Check connections and equipment status.",
    category: "communication",
    priority: 6,
  },

  NETWORK_CONFIG_ERROR: {
    id: "NETWORK_CONFIG_ERROR",
    type: "warning",
    title: "Network Configuration Error",
    message:
      "Network configuration error. Check settings and configuration files.",
    category: "communication",
    priority: 5,
  },

  // Safety related
  E_STOP_ERROR: {
    id: "E_STOP_ERROR",
    type: "error",
    title: "Emergency Stop System Error",
    message:
      "Emergency stop system error. Check E-stop buttons and safety circuits.",
    category: "safety",
    priority: 10,
  },

  BRAKE_FAILURE: {
    id: "BRAKE_FAILURE",
    type: "critical",
    title: "Brake System Failure",
    message: "Critical brake system failure. Follow emergency procedures.",
    category: "safety",
    priority: 10,
  },

  OVERLOAD_PROTECTION: {
    id: "OVERLOAD_PROTECTION",
    type: "warning",
    title: "Overload Protection Warning",
    message:
      "Overload protection warning. Monitor load conditions and reduce if necessary.",
    category: "safety",
    priority: 7,
  },

  // Environmental
  HIGH_WIND_SPEED: {
    id: "HIGH_WIND_SPEED",
    type: "warning",
    title: "High Wind Speed Detected",
    message: "High wind speed detected. Exceeds safe operating limits.",
    category: "weather",
    priority: 7,
    suggestedWidget: WidgetKey.ENVIRONMENT,
  },

  TEMPERATURE_ERROR: {
    id: "TEMPERATURE_ERROR",
    type: "error",
    title: "Temperature Sensor Error",
    message: "Temperature sensor error. Check sensor and cooling systems.",
    category: "environmental",
    priority: 6,
  },

  VENTILATION_ERROR: {
    id: "VENTILATION_ERROR",
    type: "error",
    title: "Ventilation System Error",
    message: "Ventilation system error. Check fan operation and temperatures.",
    category: "environmental",
    priority: 6,
  },

  // General
  GENERAL_SENSOR_ERROR: {
    id: "GENERAL_SENSOR_ERROR",
    type: "error",
    title: "General Sensor Error",
    message: "Sensor error detected. Check connections and calibration.",
    category: "general",
    priority: 6,
  },

  GENERAL_SYSTEM_ERROR: {
    id: "GENERAL_SYSTEM_ERROR",
    type: "error",
    title: "General System Error",
    message: "System error detected. Check system status and error logs.",
    category: "general",
    priority: 7,
  },

  // from UI mocks
  TROLLEY_2_WINCH_DISABLED: {
    id: "TROLLEY_2_WINCH_DISABLED",
    type: "warning",
    title: "Trolley 2 winch drive disabled",
    message: "One drive is disabled. Operate with care, report to maintenance.",
    category: "safety",
    priority: 7,
  },

  TACKLE_2_BRAKE_OIL_FILTER_CLOGGED: {
    id: "TACKLE_2_BRAKE_OIL_FILTER_CLOGGED",
    type: "warning",
    title: "Tackle 2 – Brake oil filter clogged",
    message: "Filter blocked when pressurized. Plan service.",
    category: "mechanical",
    priority: 6,
  },

  AUX_HOIST_OIL_LEVEL_LOW: {
    id: "AUX_HOIST_OIL_LEVEL_LOW",
    type: "error",
    title: "Aux Hoist - Oil level low",
    message: "Hydraulic fluid level is low. Refill to maintain safe operation.",
    category: "mechanical",
    priority: 8,
  },

  MAIN_HOIST_DRUM_ROPE_LAYER_UNEVEN: {
    id: "MAIN_HOIST_DRUM_ROPE_LAYER_UNEVEN",
    type: "warning",
    title: "Main hoist - Drum rope layer uneven",
    message: "Rope not spooled evenly. Monitor during lowering.",
    category: "mechanical",
    priority: 6,
  },

  MAIN_HOIST_BRAKE_FILTER_BLOCKED: {
    id: "MAIN_HOIST_BRAKE_FILTER_BLOCKED",
    type: "warning",
    title: "Main hoist brake filter blocked",
    message: "Braking power reduced. Schedule service to replace filter.",
    category: "mechanical",
    priority: 7,
  },

  AUX_HOIST_DRUM_SLACK_DETECTED: {
    id: "AUX_HOIST_DRUM_SLACK_DETECTED",
    type: "error",
    title: "Aux Hoist - Drum slack detected",
    message: "Rope slack registered. Hoisting disabled until tension applied.",
    category: "safety",
    priority: 8,
  },
};

// Helper function to create an alert from a definition
export const createAlertFromDefinition = (
  definitionKey: AlertDefinitionKey
): Omit<import("../types").Alert, "id"> => {
  const now = Date.now();
  return {
    definitionId: definitionKey,
    timestamp: new Date().toLocaleTimeString(),
    acknowledged: false,
    createdAt: now,
    interacted: false,
  };
};
